import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	MOBILE_L_BP,
	COLOR_DARK_GREEN_BUTTON,
} from "@website-builder/utilities-index";

export const CarouselContainer = styled.div`
	padding: 60px 80px 80px 80px;
	display: flex;
	.tabViewContainer {
		display: none;
	}
	.content {
		width: 60%;
		padding-left: 20px;
		margin: auto;
	}
	.heading {
		font-size: 28px;
		font-weight: ${FONT_WT_MEDIUM};
		color: ${COLOR_TEXT_PRIMARY_B2C};
		margin-bottom: 25px;
	}
	.description {
		font-size: 16px;
		font-weight: ${FONT_WT_LIGHT};
		line-height: 1.69;
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
	.imageContainer {
		width: 40%;
	}
	.slick-slide img {
		display: inherit;
	}
	.slick-dots {
		margin-top: 15px;
		bottom: -40px;
	}
	.slick-dots li {
		margin: 0px;
	}
	.slick-dots li.slick-active button:before {
		color: ${COLOR_DARK_GREEN_BUTTON};
	}
	.slick-dots li button:before {
		font-size: 15px;
		color: ${COLOR_DARK_GREEN_BUTTON};
	}
	.slick-track {
		div {
			div {
				display: flex !important;
				justify-content: center;
				img {
					width: 80% !important;
				}
			}
		}
	}
	.slick-arrow {
		display: none !important;
	}
	.slick-next {
		right: 0px;
	}
	.slick-slide {
		div {
			div {
				outline: none;
			}
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 50px;
		display: block;
		.tabViewContainer {
			display: flex;
			padding-top: 70px;
		}
		.imageContainer {
			display: none;
		}
		.content {
			width: 100%;
			padding-left: 0px;
		}
		.tabImage {
			width: 100%;
			padding: 5px;
		}
		.heading {
			font-size: 26px;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 20px 22px;
		display: flex;
		flex-direction: column-reverse;
		.imageContainer {
			display: block;
		}
		.tabViewContainer {
			display: none;
		}
		.content {
			width: 100%;
			padding-right: 0px;
			padding-left: 0px;
			margin-top: 20px;
		}
		.imageContainer {
			width: 100%;
			margin-top: 15px;
			margin-bottom: 30px;
		}
		.heading {
			text-align: left;
			font-size: 24px;
		}
		.slick-track {
			div {
				div {
					display: flex !important;
					justify-content: center;
					img {
						width: 95% !important;
					}
				}
			}
		}
	}
`;
